import * as React from 'react';

import * as styles from './index.css';
import { EEmployment } from './repositories/vacancies/entities/schemas/VacancySchema';
import { IRegion } from './types/region';

export interface IVacancy {
  company?: {
    id: number;
    age?: string;
    avatarUrl?: string;
    isTrusted?: boolean;
    isProfi?: boolean;
    name?: string;
    agencyId?: number;
    profileUrl?: string;
  };
  id: number;
  userId?: number;
  updatedHumanized?: string | null;
  specialization: string;
  region: IRegion;
  minSalary?: number;
  maxSalary?: number;
  workExperience?: number;
  employment: EEmployment;
  description: string;
  contactPhone?: string;
  contactEmail?: string;
  leftToUpdate?: string | null;
}

interface IAppProps {
  component: React.ReactNode;
}

const App = (props: IAppProps) => <div className={styles['content']}>{props.component}</div>;

export { App };
